<div class="delete_dialog_wrap">
    <div class="delete_content_wrap" [ngStyle]="{padding: padding}">
        <p class="title font_24_a32_600">{{title}}</p>
        <p class="subTitle" style="color:#000">{{subTitle}}</p>
        <ng-content></ng-content>
    </div>
    <div class="backdrop_delete_dialog"></div>
</div>